module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAAAXNSR0IArs4c6QAAAAlQTFRF////NDQ0MzMzp8TCuQAAAAJ0Uk5TAoCpHSyaAAAAN0lEQVQoz2NgGDKANRQKAoAcrlVQsACdg6KMFi6AmssFtxGdw0oj68FGIxnLBbMQg8NKG9upAAC5PyHfyVKnsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Frame.png
// module id = XAgP
// module chunks = 1